module.exports = __webpack_public_path__ + "static/media/AtivaLogo.06dd2908.png";